module.exports = __webpack_public_path__ + "img/2_26.db99a1a7.png";